"use server"
import 'server-only'
import React from 'react'
import Form from '../Form';
import { createFormAction } from '../formActions';


interface Props {
  actionPath: string;
}

export default async function SignUpPage({
  actionPath,
}: Props) {
  if (!actionPath?.trim())
    throw new Error(
      "actionPath must not be a empty string!!"
    );
  const formAction = await createFormAction({
    pathname: actionPath,
    formType:  "signup",
  });
  return (
    <div>
      <Form formAction={formAction} formType="signup" />
    </div>
  );
}
